/**
 * Bitrix Messenger
 * Date constants
 *
 * @package bitrix
 * @subpackage im
 * @copyright 2001-2020 Bitrix
 */

export const DateFormat = Object.freeze({
	groupTitle: 'groupTitle',
	message: 'message',
	recentTitle: 'recentTitle',
	recentLinesTitle: 'recentLinesTitle',
	readedTitle: 'readedTitle',
	default: 'default',
	vacationTitle: 'vacationTitle',
});